<template>
  <div :class="'TheNavigation '+class_hide_factsheet">
    
    <ul :class="is_home" v-if="is_home=='nav_home'" class="main_nav">
      <li v-for="(page,index) in $t('pages_')" v-if="page.key!=undefined && page.hide!=true" v-bind:key="page.key" :class="page.class">
        <router-link :to="$i18nRoute({ name: page.key })">
          <span v-if="index==0"><i class="fas fa-home"></i></span>
          <span v-else>{{ page.name }}</span>

          <ul v-if="page.submenu" class="submenu">
            <li v-for="subpage in page.submenu" v-bind:key="subpage.key">
              <router-link :to="$i18nRoute({ name: subpage.key })">
                {{ subpage.name }}
              </router-link>
            </li>
          </ul>
        </router-link>
      </li>
    </ul>

    <ul :class="is_home" v-if="is_home!='nav_home'" class="main_nav">
      <li v-for="(page,index) in $t('pages_')" v-if="page.key!=undefined && page.hide!=true" v-bind:key="page.key" :class="page.class">

        <router-link :to="$i18nRoute({ name: page.key })" v-if="page.key != ''">
          {{ page.name }}

          <ul v-if="page.submenu" class="submenu">
            <li v-for="subpage in page.submenu" v-bind:key="subpage.key">
              <router-link :to="$i18nRoute({ name: subpage.key })">
                {{ subpage.name }}
              </router-link>
            </li>
          </ul>
        </router-link>

        <a href="#" v-else="page.key == ''">
          {{ page.name }}
          <ul v-if="page.submenu" class="submenu">
            <li v-for="subpage in page.submenu" v-bind:key="subpage.key">
              <router-link :to="$i18nRoute({ name: subpage.key })">
                {{ subpage.name }}
              </router-link>
            </li>
          </ul>
        </a>

      </li>
    </ul>

  </div>
</template>

<script>
import { Trans } from '@/plugins/Translation'

export default {
  props : {
    is_home : ""
  } , 

  data : ()=>{
    return {
      class_hide_factsheet : ""
    }
  },
  mounted(){

    // this.$t('pages_')
    if ( process.env.VUE_APP_HIDE_FACTSHEETS != undefined )
    {
      if ( process.env.VUE_APP_HIDE_FACTSHEETS == true )
      {
        delete this.$t('pages_').factsheets ; 
        this.class_hide_factsheet = "hide_factsheet" ; 
      }
    }

  },
  computed: {
    supportedLanguages () {
      return Trans.supportedLanguages
    },
    currentLanguage () {
      return Trans.currentLanguage
    }
  },
  methods: {
    changeLanguage (e) {
      const lang = e.target.value
      const to = this.$router.resolve({ params: { lang } })
      return Trans.changeLanguage(lang).then(() => {
        this.$router.push(to.location)
      })
    },
    isCurrentLanguage (lang) {
      return lang === this.currentLanguage
    }
  }
}
</script>

<style lang="scss">

.TheNavigation{
  display: none; 
}
// mixin for-tablet-portrait-up {
@media (min-width: 1200px) { 
  .TheNavigation {
    display: block ; 
    position: absolute;
    right: 0px;
    top: -5px;
    transition: all 0.2s ease-in-out;
    &.scrolled{
      top: 10px;
      position: fixed;
      right: 15%;
    }
    ul.main_nav{
      li{
        list-style-type:none;
        display: inline-block;
        a {
          text-decoration: none;
          font-weight: bold;
          font-size: 1em;
          color: #1E7FB8 !important;
          margin: 0 .5rem;
          transition: all 0.2s ease-in-out;
          &:hover {
            ul.submenu{
              display: block;
            }
          }
          &:hover,&.is-active{
            padding-bottom:10px;
            border-bottom:solid 2px #1E7FB8;
          }
        }
        &.disabled{
          a{
            color: #ccc ; 
          }
        }
        ul.submenu{
          display: none ;
          padding-left: 0;
          background: #1E7FB8 ;
          position: absolute;
          max-width: 250px;
          min-height: 130px;
          z-index: 2;
          margin-left: -10px;
          top: 50px;
          padding-top: 15px;
          li{
            padding: 5px;
            width: 100%;
            a{
              color: #000;
              padding: 0 !important;
              font-size: 0.8em;
              text-align: left ; 
            }
          }
        }
      }
    }
  }

  #bloc-nav{
    background: #1E7FB8 ;
    height: 50px;
    position: absolute;
    width: 100%;
    z-index: 99 ;
    .TheNavigation {
      position: relative;
      top: 0;
      ul.nav_home{
        z-index: 3 ; 
        padding-left: 0px;
        li{
          &:first-child{
            padding-left: 0; 
            margin-left: 0 ; 
            a{
              margin-left: 0px; 
              text-align: left;
              padding-left: 0;
            }
          }
          a{
            color: #fff !important; 
            display: block;
            padding: 13px 80px;
            &:hover,&.is-active{
              color: #ccc !important; 
              padding-bottom:5px;
              border-bottom:none;
            }
          }
        }
      }
      &.hide_factsheet{
        ul.nav_home{
          li{
            a{
              padding: 13px 55px;
            } 
          }
        }
      }
    }
  }
}

// mixin for-tablet-portrait-up {
@media (max-width: 600px) { 

  #bloc-nav{
    height: 15px;
    .TheNavigation{
      display: none;
      ul.nav_home{
        display: none;
      }
    }
  }

  ul.main_nav{
    display: none;
  }

}

</style>
